import { render } from "./CmsSettings.vue?vue&type=template&id=440ba40c&scoped=true"
import script from "./CmsSettings.vue?vue&type=script&lang=js"
export * from "./CmsSettings.vue?vue&type=script&lang=js"

import "./CmsSettings.vue?vue&type=style&index=0&id=440ba40c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440ba40c"]])

export default __exports__